/* istanbul ignore file */
import React from "react";
import PropTypes from "prop-types";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Divider from "@mui/material/Divider";
import Typography from "@material-ui/core/Typography";

import Button from "../../Button/Button";
import JDPTooltip, { ICON_NONE } from "../../UI/Tooltip/Tooltip";
import theme from "../../../themes/theme.module.css";
import { JDP_API_URL } from "../../../utils/HttpClientProvider";

const OtherActionsDropdownButton = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const sampleReportFormSubmitBtnRef = React.useRef();
  const sampleQCReportFormSubmitBtnRef = React.useRef();

  // const REPORT_PROJECT_OVERVIEW = "REPORT_PROJECT_OVERVIEW";
  const REPORT_SAMPLE = "REPORT_SAMPLE";
  const REPORT_SAMPLE_QC = "REPORT_SAMPLE_QC";

  const {
    // honeycomb,
    admin,
    handleManageFiles,
    onMenuClose,
    size,
    style,
    handleRefineAndDownload,
    selected, // array of SPIDs
  } = props;

  const handleClick = (event) => {
    if (selected?.length > 0) {
      setAnchorEl(event.currentTarget);
    }
  };

  /* istanbul ignore next */
  const handleDownloadDropdownClose = () => {
    // Close dropdown menu
    setAnchorEl(null);
    if (onMenuClose) onMenuClose();
    return true;
  };

  const handleDownloadReport = (atype) => {
    if (atype === REPORT_SAMPLE) {
      sampleReportFormSubmitBtnRef.current.click();
    } else if (atype === REPORT_SAMPLE_QC) {
      sampleQCReportFormSubmitBtnRef.current.click();
    }
  };

  const btnStyle = {
    height: 48,
    ...style,
  };

  const itemStyle = {
    cursor: "pointer",
    paddingTop: 8,
    paddintBottom: 8,
  };

  const labelStyle = {
    color: "#302E2E",
    fontFamily: "Public Sans",
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    width: "100%",
  };

  const subItemStyle = {
    ...itemStyle,
    paddingLeft: 36,
  };

  const arrowStyle = { fontSize: 28 };

  const pulldownWidth = 300;
  return (
    <>
      <Button
        aria-haspopup="true"
        onClick={handleClick}
        color="primary"
        size={size}
        className="button"
        endIcon={
          anchorEl ? (
            <KeyboardArrowUpIcon style={arrowStyle} />
          ) : (
            <KeyboardArrowDownIcon style={arrowStyle} />
          )
        }
        style={{ ...btnStyle, width: pulldownWidth }}
        disabled={!selected?.length > 0}
        id="download-btn-id"
        variant={selected?.length > 0 ? "outlined" : "contained"}
      >
        File & Report Operations
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleDownloadDropdownClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          style: {
            width: pulldownWidth,
          },
        }}
      >
        <MenuItem
          onClick={handleRefineAndDownload}
          style={{ ...itemStyle, ...labelStyle }}
        >
          Select & Download Files
        </MenuItem>

        <MenuItem
          sx={{ "&:hover": { backgroundColor: "white" } }}
          style={{
            ...itemStyle,
            ...labelStyle,
            paddingTop: 14,
            fontFamily: "Public Sans",
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal",
            cursor: "default",
            color: theme.lake500,
          }}
          disableRipple
        >
          Download
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            handleDownloadReport(REPORT_PROJECT_OVERVIEW);
          }}
          style={{ ...subItemStyle }}
        >
          <JDPTooltip
            title="a .csv file listing a project-level metadata"
            placement="right"
            iconType={ICON_NONE}
          >
            <Typography style={labelStyle}>Project Overview Report</Typography>
          </JDPTooltip>
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            handleDownloadReport(REPORT_SAMPLE);
          }}
          style={subItemStyle}
        >
          <JDPTooltip
            title="a .csv file that includes sample-level metadata"
            placement="right"
            iconType={ICON_NONE}
          >
            <Typography style={labelStyle}>Sample Report</Typography>
          </JDPTooltip>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDownloadReport(REPORT_SAMPLE_QC);
          }}
          style={subItemStyle}
        >
          <JDPTooltip
            title="lists all the samples received for a project, sample metadata and QC results"
            placement="right"
            iconType={ICON_NONE}
          >
            <Typography style={labelStyle}>Sample QC Report</Typography>
          </JDPTooltip>
        </MenuItem>

        {admin && <Divider style={{ marginTop: 18 }} />}
        {admin && (
          <MenuItem
            onClick={handleManageFiles}
            style={{
              ...itemStyle,
              ...labelStyle,
              fontStyle: "italic",
              paddingBottom: 18,
            }}
          >
            Manage File Properties
          </MenuItem>
        )}
      </Menu>
      {/* the hidden sample report download form */}
      <form
        action={`${JDP_API_URL}/reports/sample_report/`}
        method="POST"
        style={{ display: "none" }}
      >
        <input
          data-testid="form-input-ids"
          type="hidden"
          name="its_sp_ids"
          value={selected}
        />
        <input
          ref={sampleReportFormSubmitBtnRef}
          type="submit"
          name="submit"
          value="submit"
        />
      </form>
      {/* the hidden sample qc report download form */}
      <form
        action={`${JDP_API_URL}/reports/sample_qc_report/`}
        method="POST"
        style={{ display: "none" }}
      >
        <input
          data-testid="form-input-ids"
          type="hidden"
          name="its_sp_ids"
          value={selected}
        />
        <input
          ref={sampleQCReportFormSubmitBtnRef}
          type="submit"
          name="submit"
          value="submit"
        />
      </form>
    </>
  );
};

export default OtherActionsDropdownButton;

OtherActionsDropdownButton.defaultProps = {
  admin: false,
  handleManageFiles: () => {},
  onMenuClose: null,
  size: "medium",
  style: {},
  selected: null,
};

OtherActionsDropdownButton.propTypes = {
  // honeycomb: PropTypes.shape().isRequired,
  admin: PropTypes.bool,
  handleManageFiles: PropTypes.func,
  handleRefineAndDownload: PropTypes.func.isRequired,
  onMenuClose: PropTypes.func,
  size: PropTypes.string,
  style: PropTypes.shape(),
  selected: PropTypes.arrayOf(PropTypes.number),
};
